// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1ZzFj","content":"RecentSearches_content__1fHhB"};